
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.185 1.574A1.867 1.867 0 011.878.5h20.25a1.88 1.88 0 011.448 3.066l-8.573 10.476V20c0 .567-.32 1.088-.83 1.34a1.498 1.498 0 01-1.57-.14l-3-2.25a1.49 1.49 0 01-.6-1.2v-3.708L.425 3.562a1.87 1.87 0 01-.24-1.988z","fill":"#9C27B0"}})])
          )
        }
      }
    